import { useContext, useEffect, useState } from "react";
import image_consultation from "../img/consultation_image.png";
import { ErrorMessage, Field, Formik } from "formik";
import { Form, Row, Col, Button } from "react-bootstrap";
import PhoneInputWithCountrySelect from "react-phone-number-input";
import * as Yup from "yup";
import PremiumHeader from "../components/PremiumHeader";
import useAxiosRequests from "../hooks/useAxiosRequest";
import ExternalRoutes from "../config/ExternalRoutes";
import AuthContext from "../context/AuthContext";
import { MessageContext } from "../context/MessageContext";
import { useNavigate } from "react-router";

function Consultation() {
    const [phoneNumber, setPhoneNumber] = useState("");
    const { sendRequest } = useAxiosRequests();
    const { userInfo } = useContext(AuthContext);
    const { showSuccess, showError } = useContext(MessageContext);
    const navigate = useNavigate();
    const [callToRemember, setCallToRemember] = useState(null);

    const validationSchema = Yup.object().shape({
        callRmFirstname: Yup.string().required("Le prénom est requis"),
        callRmLastname: Yup.string().required("Le nom est requis"),
        callRmbTel: Yup.string()
            .required("Le téléphone est requis")
            .matches(/^\+?[0-9]{10,15}$/, "Numéro de téléphone invalide"),
    });

    const onHandleSubmit = async (values, { setSubmitting }) => {
        const conUserId = ExternalRoutes.userInformation.show + userInfo?.id;
        const body = {
            callRmFirstname: values.callRmFirstname,
            callRmLastname: values.callRmLastname,
            callRmbTel: values.callRmbTel,
        };

        try {
            const response = await sendRequest({
                method: "POST",
                url: ExternalRoutes.callRemember.add,
                body,
            });

            if (response.status === "error" || ![200, 201, 202, 204].includes(response.statusCode)) {
                showError(response.message || "L’ajout a échoué en raison d’une erreur");
            } else {
                showSuccess("Merci, nous reviendrons vers vous rapidement.");
                navigate("/");
            }
        } catch (error) {
            showError(error.message || "Erreur inattendue");
        } finally {
            setSubmitting(false);
        }
    };

    const fetchData = async () => {
        try {
            const response = await sendRequest({
                method: "GET",
                url: ExternalRoutes.callRemember.show + userInfo?.id,
            });

            if (response && response.data) {
                setCallToRemember(response.data);
            }
        } catch (error) {
            showError(error.message || "Impossible de récupérer les données");
        }
    };

    useEffect(() => {
        if (userInfo?.id) {
            fetchData();
        }
        if (userInfo?.tel) {
            setPhoneNumber(userInfo.tel);
        }
    }, [userInfo]);

    const openWhatsApp = () => {
        const phoneNumber = '33184808122';
        const message = 'Bonjour, je souhaite avoir des informations';
        const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
        window.open(url, '_blank');
    };

    const initialValues = {
        callRmFirstname: userInfo?.firstName || "",
        callRmLastname: userInfo?.lastName || "",
        callRmbTel: userInfo?.tel || userInfo?.tel || "",
    };

    return (
        <section className="kl-contenu-consultation">
            <div className="container">
                <PremiumHeader />
                <div className="kl-consultation-title">
                    <h2>Laissez vous guider par notre expertise.</h2>
                </div>
                <div className="kl-image-consultation-phone">
                    <img src={image_consultation} alt="consultation" />
                </div>
                <div className="kl-consultation-offered">
                    <span>Consultation offerte</span>
                </div>
                <div className="kl-consultation-text">
                    <p>Laissez-nous vos coordonnées et nous vous rappellerons dans les meilleurs délais</p>
                </div>
            </div>

            <Formik
                enableReinitialize
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onHandleSubmit}
            >
                {({
                    handleSubmit,
                    isValid,
                    isSubmitting,
                    setFieldValue,
                    errors,
                    touched,
                }) => (
                    <form onSubmit={handleSubmit} noValidate autoComplete="off">
                        <div className="kl-consultation-information">
                            <Row className="gx-3">
                                <Col xs={6}>
                                    <Form.Group controlId="formFirstName">
                                        <Form.Label>Prénom</Form.Label>
                                        <Field
                                            as={Form.Control}
                                            type="text"
                                            name="callRmFirstname"
                                            className={`kl-input-form ${touched.callRmFirstname && errors.callRmFirstname ? "is-invalid" : ""}`}
                                        />
                                        <ErrorMessage name="callRmFirstname" component="small" className="text-danger d-block mt-1" />
                                    </Form.Group>
                                </Col>
                                <Col xs={6}>
                                    <Form.Group controlId="formLastName">
                                        <Form.Label>Nom</Form.Label>
                                        <Field
                                            as={Form.Control}
                                            type="text"
                                            name="callRmLastname"
                                            className={`kl-input-form ${touched.callRmLastname && errors.callRmLastname ? "is-invalid" : ""}`}
                                        />
                                        <ErrorMessage name="callRmLastname" component="small" className="text-danger d-block mt-1" />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Form.Group controlId="formPhoneNumber">
                                <Form.Label>Téléphone</Form.Label>
                                <PhoneInputWithCountrySelect
                                    international
                                    // defaultCountry="FR"
                                    value={phoneNumber}
                                    onChange={(value) => {
                                        setPhoneNumber(value);
                                        setFieldValue("callRmbTel", value);
                                    }}
                                    className="kl-input-form kl-input-select-phone"
                                />
                                <ErrorMessage name="callRmbTel" component="small" className="text-danger d-block mt-1" />
                            </Form.Group>
                        </div>
                        <div className="kl-button-valided-consultation text-center">
                            <Button type="submit" disabled={!isValid || isSubmitting}>
                                {isSubmitting ? "Validation en cours..." : "Se faire rappeler"}
                            </Button>
                        </div>
                    </form>
                )}
            </Formik>

            <div className="kl-title-consultation-info">
                <h2>Ou écrivez-nous</h2>
            </div>
            <div className="kl-text-consultation-info">
                <span>Nos experts-comptables sont disponibles du lundi au vendredi de 8h à 21h</span>
            </div>
            <div className="kl-whatsapp-button">
                <button onClick={openWhatsApp}>Chat sur Whatsapp</button>
                <svg width="65" height="68" viewBox="0 0 65 68" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.7315 56.3755L18.7021 56.9733C22.7807 59.4881 27.4568 60.8181 32.2253 60.8207H32.2357C46.8803 60.8207 58.7993 48.4403 58.8048 33.2241C58.8071 25.8497 56.0463 18.9165 51.0299 13.6999C46.0132 8.48426 39.3432 5.60991 32.2452 5.60684C17.5896 5.60684 5.6706 17.9854 5.66507 33.2015C5.66313 38.4157 7.06706 43.494 9.7271 47.8873L10.3594 48.9316L7.67461 59.1149L17.7315 56.3755ZM0 67.0031L4.53501 49.7985C1.73776 44.7632 0.266208 39.0513 0.268512 33.2C0.27533 14.8935 14.6146 0 32.2364 0C40.7873 0.0038294 48.8133 3.4614 54.8488 9.73722C60.8836 16.0129 64.2061 24.355 64.2034 33.2268C64.1959 51.5323 49.8536 66.4287 32.2364 66.4287C32.2351 66.4287 32.237 66.4287 32.2364 66.4287H32.2227C26.8728 66.4268 21.6159 65.0325 16.9469 62.3867L0 67.0031Z" fill="white" />
                    <path d="M1.37202 33.2161C1.37009 38.8644 2.7906 44.3788 5.49165 49.2402L1.11328 65.8493L17.4727 61.3926C21.9801 63.9445 27.0549 65.2917 32.2196 65.2934H32.2329C49.2411 65.2934 63.0849 50.914 63.0923 33.2413C63.0955 24.6767 59.8884 16.6245 54.0616 10.5655C48.2358 4.50725 40.4878 1.16906 32.2316 1.16504C15.2225 1.16504 1.3794 15.5424 1.37202 33.2161ZM32.2329 65.2934C32.2323 65.2934 32.2326 65.2934 32.2329 65.2934V65.2934Z" fill="url(#paint0_linear_6657_3648)" />
                    <path d="M0.268512 33.2088C0.266576 39.0601 1.73813 44.7727 4.53538 49.8074L0 67.011L16.9464 62.3946C21.6157 65.04 26.8723 66.4342 32.2222 66.4365H32.2359C49.8531 66.4365 64.1954 51.5401 64.2028 33.2346C64.2058 24.3623 60.8832 16.0205 54.8483 9.74504C48.8124 3.4696 40.7869 0.0116419 32.2359 0.0078125C14.615 0.0078125 0.275345 14.9013 0.267974 33.2078M10.3597 48.9399L9.72712 47.8961C7.06707 43.5022 5.66315 38.424 5.66508 33.2103C5.67089 17.9951 17.5896 5.6156 32.2452 5.6156C39.3424 5.61847 46.0126 8.49311 51.0299 13.7087C56.0467 18.9246 58.8072 25.8584 58.8052 33.2319C58.7987 48.4481 46.8798 60.8285 32.2352 60.8285H32.2248C27.4564 60.8256 22.7799 59.4958 18.7016 56.9814L17.7309 56.3836L7.67423 59.123L10.3597 48.9399ZM32.2359 66.4365C32.2352 66.4365 32.2355 66.4365 32.2359 66.4365V66.4365Z" fill="#EBEBEB" />
                    <path fillRule="evenodd" clipRule="evenodd" d="M24.2488 19.3244C23.6504 17.9423 23.0207 17.9147 22.4515 17.8904C21.9857 17.8698 21.453 17.8711 20.9208 17.8711C20.388 17.8711 19.5227 18.0788 18.791 18.9093C18.0586 19.7397 15.9951 21.7472 15.9951 25.83C15.9951 29.9132 18.8577 33.8586 19.2565 34.4128C19.656 34.966 24.7823 43.6127 32.9004 46.9388C39.6478 49.7031 41.0209 49.1533 42.4853 49.0148C43.9498 48.8767 47.2112 47.008 47.8766 45.0701C48.5423 43.1325 48.5423 41.4716 48.3427 41.1248C48.1431 40.7789 47.6103 40.5712 46.8116 40.1565C46.0126 39.7415 42.0858 37.7337 41.3538 37.4567C40.6214 37.1801 40.0889 37.042 39.5561 37.8728C39.0237 38.7026 37.4939 40.5713 37.0278 41.1248C36.5619 41.6794 36.0958 41.7486 35.2971 41.3335C34.4981 40.9171 31.9255 40.0417 28.8738 37.2149C26.4992 35.0153 24.8962 32.2989 24.4301 31.468C23.9642 30.6382 24.3803 30.1887 24.7808 29.7749C25.1397 29.4031 25.5798 28.806 25.9793 28.3217C26.3779 27.837 26.5108 27.4912 26.7771 26.9376C27.0436 26.3838 26.9103 25.8991 26.7107 25.484C26.5108 25.0689 24.9591 20.9654 24.2488 19.3244Z" fill="white" />
                    <defs>                            <linearGradient id="paint0_linear_6657_3648" x1="32.1031" y1="65.8426" x2="32.1031" y2="1.15824" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#20B038" />
                        <stop offset="1" stopColor="#60D66A" />
                    </linearGradient>
                    </defs>
                </svg>
            </div>
        </section>
    );
}

export default Consultation;
